import { render, staticRenderFns } from "./file-card-big.vue?vue&type=template&id=a27c1600&scoped=true&"
import script from "./file-card-big.vue?vue&type=script&lang=js&"
export * from "./file-card-big.vue?vue&type=script&lang=js&"
import style0 from "./file-card-big.vue?vue&type=style&index=0&id=a27c1600&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27c1600",
  null
  
)

export default component.exports